import { useEffect, useState } from "react";
import AppLayout from "../../../components/AppLayout/AppLayout";

const timelineEntries = [
  {
    time: "05:45 pm",
    from: "Udyog Vihar, Sector 18, Gurugram, Haryana 122015",
    to: "U55/11-A DLF Phase 3, Sector 24, Gurugram, Haryana",
    remark: "Lorem Ipsum is a useless text, just useless......",
  },
  {
    time: "11:45 am",
    from: "Udyog Vihar, Sector 18, Gurugram, Haryana 122015",
    to: "U55/11-A DLF Phase 3, Sector 24, Gurugram, Haryana",
    remark: "Lorem Ipsum is a useless text, just useless......",
  },
  {
    time: "08:45 am",
    from: "Udyog Vihar, Sector 18, Gurugram, Haryana 122015",
    to: "U55/11-A DLF Phase 3, Sector 24, Gurugram, Haryana",
    remark: "Lorem Ipsum is a useless text, just useless......",
  },
];

function pad(n) {
  return String(n).padStart(2, "0");
}

export default function TripDetail(trip) {
  const [elapsed, setElapsed] = useState(8 * 3600 + 15 * 60 + 25);
  

  useEffect(() => {
    const timer = setInterval(() => setElapsed((s) => s + 1), 1000);
    return () => clearInterval(timer);
  }, []);

  const hh = pad(Math.floor(elapsed / 3600));
  const mm = pad(Math.floor((elapsed % 3600) / 60));
  const ss = pad(elapsed % 60);

  const inputStyle = {
    width: "100%", padding: "9px 12px", border: "1px solid #d0c8f0",
    borderRadius: 8, fontSize: 13, color: "#333", background: "#fff",
    boxSizing: "border-box",
  };

  return (
    <AppLayout><div style={{ minHeight: "100vh", background: "#f7f7f7" }}>

      {/* Header */}
    

      {/* Stopwatch + KM Fields */}
      <div style={{ background: "#fff", padding: "20px 16px 16px", borderBottom: "0.5px solid #eee" }}>

        {/* Stopwatch */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12, marginBottom: 10 }}>
          {[hh, mm, ss].map((unit, i) => (
            <>
              <div key={i} style={{
                width: 52, height: 52, borderRadius: "50%", background: "#f0f0f0",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 26, fontWeight: 500, color: "#555",
              }}>
                {unit}
              </div>
              {i < 2 && (
                <span key={`sep-${i}`} style={{ fontSize: 24, color: "#888", fontWeight: 300 }}>:</span>
              )}
            </>
          ))}
        </div>

        <p style={{ textAlign: "center", fontSize: 12, color: "#555", margin: "0 0 16px" }}>
          Journey started at -{" "}
          <span style={{ color: "#e05c8a", fontWeight: 500 }}>08:34 am</span>
        </p>

        {/* KM Fields */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          <div>
            <label style={{ fontSize: 11, color: "#888", display: "block", marginBottom: 4 }}>
              Kilometer Count <em>(Starting)</em>
            </label>
            <input style={inputStyle} value={trip?.start ?? "54,563"} readOnly />
          </div>

          <div>
            <label style={{ fontSize: 11, color: "#888", display: "block", marginBottom: 4 }}>
              Kilometer Count <em>(Image)</em>
            </label>
            <FileField filename="1010002.pdf" />
          </div>

          <div>
            <label style={{ fontSize: 11, color: "#888", display: "block", marginBottom: 4 }}>
              Kilometer Count <em>(Ending)</em>
            </label>
            <input style={inputStyle} value={trip?.end ?? "54,780"} readOnly />
          </div>

          <div>
            <label style={{ fontSize: 11, color: "#888", display: "block", marginBottom: 4 }}>
              Kilometer Count <em>(Image)</em>
            </label>
            <FileField filename="1010002.pdf" />
          </div>
        </div>
      </div>

      {/* Timeline */}
      <div style={{ padding: 14 }}>
        <div style={{ background: "#534AB7", borderRadius: 8, padding: "12px 14px", marginBottom: 14 }}>
          <span style={{ color: "#fff", fontSize: 14, fontWeight: 500 }}>Timeline</span>
        </div>

        {timelineEntries.map((entry, index) => (
          <TimelineItem
            key={index}
            entry={entry}
            isLast={index === timelineEntries.length - 1}
          />
        ))}
      </div>
    </div></AppLayout>
    
  );
}

function FileField({ filename }) {
  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 8,
      padding: "9px 12px", border: "1px solid #d0c8f0",
      borderRadius: 8, background: "#fff", cursor: "pointer",
    }}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke="#534AB7" strokeWidth="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
      </svg>
      <span style={{ fontSize: 12, color: "#534AB7", flex: 1 }}>{filename}</span>
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2">
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
        <polyline points="15 3 21 3 21 9" />
        <line x1="10" y1="14" x2="21" y2="3" />
      </svg>
    </div>
  );
}

function TimelineItem({ entry, isLast }) {
  return (
    <div style={{ display: "flex", gap: 0, marginBottom: 0 }}>

      {/* Time label */}
      <div style={{ width: 52, fontSize: 11, color: "#888", textAlign: "right",
        paddingRight: 10, paddingTop: 16, flexShrink: 0 }}>
        {entry.time}
      </div>

      {/* Dot + dashed line */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: 16, flexShrink: 0 }}>
        <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#534AB7", marginTop: 18, flexShrink: 0 }} />
        {!isLast && (
          <div style={{
            flex: 1, width: 2, minHeight: 20,
            backgroundImage: "repeating-linear-gradient(to bottom, #b0a8e0 0, #b0a8e0 4px, transparent 4px, transparent 8px)",
          }} />
        )}
      </div>

      {/* Content card */}
      <div style={{
        flex: 1, background: "#fff", border: "0.5px solid #e0d8f5",
        borderRadius: 10, margin: "8px 0 8px 8px", overflow: "hidden",
      }}>
        {[
          { key: "From",   value: entry.from },
          { key: "To",     value: entry.to },
          { key: "Remark", value: entry.remark },
        ].map(({ key, value }, i, arr) => (
          <div key={key} style={{
            display: "flex", borderBottom: i < arr.length - 1 ? "0.5px solid #eee" : "none",
          }}>
            <div style={{
              width: 64, background: "#eeedfe", padding: "10px",
              fontSize: 11, fontWeight: 500, color: "#534AB7", flexShrink: 0,
            }}>
              {key}
            </div>
            <div style={{ padding: "10px", fontSize: 12, color: "#333", lineHeight: 1.4 }}>
              {value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}